export const MAX_SUB_AREA_SELECTION = 5;
export const MAX_ROAD_SELECTION = 5;
